<template>
  <div class="unsolicited-items el-input-grid">
    <el-tooltip
      :disabled="!selectedContent"
      :visible-arrow="false"
      :content="selectedContent"
      placement="top"
    >
      <el-select
        id="unsolicited-select"
        v-close-on-zoom
        :value="selected"
        :placeholder="placeholder"
        :filterable="true"
        :default-first-option="true"
        class="unsolicited-select"
        :disabled="readonly"
        @input="(unsolicitedId) => selectUnsolicited(unsolicitedId)"
      >
        <el-option
          v-for="unsolicitedItem in items"
          :key="unsolicitedItem.id"
          :label="unsolicitedItem.options.answer.en"
          :value="unsolicitedItem.id"
        />
      </el-select>
    </el-tooltip>
    <help-tooltip v-if="!selected" type="warning">
      An option must be selected. Data will not be saved.
    </help-tooltip>
    <help-tooltip v-if="unsolicitedErrors.length" type="error">
      <span v-for="error in unsolicitedErrors" :key="error.message">{{
        error.message
      }}</span>
    </help-tooltip>
  </div>
</template>

<script>
import get from 'lodash/get';
import nodeMixins from './mixins/NodeMixins';
import HelpTooltip from '../../common/components/HelpTooltip';

export default {
  name: 'unsolicited-items',
  components: {
    HelpTooltip,
  },
  mixins: [ nodeMixins ],
  props: {
    emitter: {
      type: Object,
      default: () => {}
    },
    items: {
      type: Array,
      default: () => []
    },
    selected: {
      type: String,
      default: null
    },
    control: {
      type: Object,
      default: () => {}
    },
    readonly: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Unsolicited item'
    },
  },
  data() {
    return {
      state: {
        id: this.selected,
      },
    };
  },
  computed: {
    selectedContent() {
      const item = (this.items || []).find(i => i.id === this.state.id);
      return get(item, 'options.answer.en');
    },
    unsolicitedErrors() {
      return this.getErrorsByIdList(['missingQuestion', 'invalidQuestion'])
    }
  },
  methods: {
    selectUnsolicited(unsolicitedId) {
      this.state.id = unsolicitedId;
      this.update();
    },
    update() {
      this.$emit('update', this.state.id);
    },
  },
};
</script>

<style scoped>
.unsolicited-items {
  display: flex;
}
.unsolicited-select {
  width: 100%;
}
.el-input-grid {
  display: grid;
  grid-template-columns: 1fr auto;
}
.help-tooltip {
  margin-left: 7px;
  margin-top: 7px;
}
</style>
